export default __webpack_public_path__ + "static/media/DarkBlue0000.5b836d44.png";